import type { Component } from "solid-js"
import { Dialog } from "@/designSystem/components/dialog"
import { SubscriptionPrompt } from "@/pages/auth/subscription-prompt"

export interface PublicationForUpgrade {
  id: string
  name: string
  subscriptionTiers: Array<{
    id: string
    name: string
    description: string | null
    monthlyPriceCents: number
    annualPriceCents: number | null
    canPurchase: boolean
  }>
  sub?: {
    id: string
    tier?: {
      id: string
      name: string
    } | null
  } | null
  author: {
    id: string
    authorName: string | null
    profileImage: string | null
  } | null
}

interface UpgradeModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  requiredTierIds: string[]
  publication: PublicationForUpgrade
  onSuccess: () => void
}

export const UpgradeModal: Component<UpgradeModalProps> = props => {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange} size="medium">
      <SubscriptionPrompt
        tiers={props.publication.subscriptionTiers ?? []}
        publicationId={props.publication.id}
        requiredTierIds={props.requiredTierIds}
        userId={props.publication.author?.id ?? ""}
        subscriptionId={props.publication.sub?.id}
        currentTierName={props.publication.sub?.tier?.name}
        onSuccess={() => {
          props.onSuccess()
          props.onOpenChange(false)
        }}
        onError={error => {
          console.error("Tier selection error:", error)
        }}
      />
    </Dialog>
  )
}
